<template>
  <div class="header-container">
    <div class="header">
      <a href="/m" style="display: flex; align-items: center">
        <img class="logo" src="@/assets/images/logo.png" alt="" />
      </a>
    </div>
    <div class="nav">
      <el-menu
        :default-active="activeIndex"
        text-color="#000000"
        class="nav-content"
        mode="horizontal"
        @select="handleSelect"
        active-text-color="#053780"
      >
        <el-menu-item index="/m">首页</el-menu-item>
        <el-menu-item
          index="/m-introduction/idea"
          :class="
            activeIndex == '/m-introduction/idea' ||
            activeIndex == '/m-introduction/os' ||
            activeIndex == '/m-introduction/rules' ||
            activeIndex == '/m-introduction/committee'
              ? 'actionStyle'
              : ''
          "
        >
          专委会介绍
        </el-menu-item>
        <el-menu-item
          index="/m-news/list"
          :class="
            activeIndex == '/m-news/list' ||
            activeIndex == '/m-news/notice' ||
            activeIndex == '/m-news/policyNews'
              ? 'actionStyle'
              : ''
          "
        >
          新闻动态
        </el-menu-item>
        <el-menu-item
          index="/m-kb/doc"
          :class="
            activeIndex == '/m-kb/doc' ||
            activeIndex == '/m-kb/term' ||
            activeIndex == '/m-kb/codePractice'
              ? 'actionStyle'
              : ''
          "
        >
          技术专区
        </el-menu-item>
        <el-menu-item
          index="/m-centigrade/introduce"
          :class="
            activeIndex == '/m-centigrade/introduce' ||
            activeIndex == '/m-centigrade/rights'
              ? 'actionStyle'
              : ''
          "
        >
          成员服务
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import myMixin from "@/mixins/index";
export default {
  name: "mHeader",
  mixins: [myMixin],
  data() {
    return {
      activeIndex: "/m",
    };
  },
  created() {},
  computed: {
    isMobile() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.activeIndex = val.path;
      },
    },
  },
  methods: {
    handleSelect(key) {
      if (this.activeIndex === key) return;
      if (this.activeIndex == "/m" && key == "/m") return;
      if (key) {
        if (key == "m") {
          this.$router.push({ name: "m" });
        } else {
          this.$router.push({ path: key });
        }
      }
      // switch (key) {
      //   case "home":
      //     this.$router.push({ name: "home" });
      //     break;
      //   case "introduction":
      //     this.$router.push({ path: "/introduction/idea" });
      //     break;
      //   case "newList":
      //     this.$router.push({ path: "/news/list" });
      //     break;
      //   case "activityList":
      //     this.$router.push({ path: "/activity/summit" });
      //     break;
      //   case "standard":
      //     this.$router.push({ path: "/standard/completed" });
      //     break;
      //   case "kb":
      //     this.$router.push({ path: "/kb/doc" });
      //     break;
      //   case "centigradeIndex":
      //     this.$router.push({ path: "/centigrade/display" });
      //     break;
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.header-container {
  position: fixed;
  z-index: 98;
  top: 0;
  left: 0;
  right: 0;

  .header {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 0.5rem;
    display: flex;
    align-items: center;
    padding: 0.1rem 0.15rem;
    box-sizing: border-box;
    background-color: #fff;

    .logo {
      width: 80%;
    }
  }
  .nav {
    position: fixed;
    top: 0.5rem;
    left: 0;
    right: 0;
    width: 100vw;
    height: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    background-color: #fff;

    .nav-content {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
    }
    .el-menu {
      display: flex;
      justify-content: space-between;
    }
    .el-menu.el-menu--horizontal {
      border: none;
    }
    .el-menu-item {
      height: 100%;
      padding: 0 !important;
      display: flex;
      font-size: 0.13rem;
      align-items: center;
      border-bottom: none !important;
      text-decoration: none !important;
    }
  }
  .el-menu--popup-bottom-start {
    margin-top: 0;
  }
  .el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
    color: #053780;
    font-size: 0.13rem;
    font-weight: 700;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
  }
  .actionStyle {
    font-size: 0.13rem;
    font-weight: 700;
    color: #053780 !important;
  }
}
</style>
